import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query'
import { createApiCall } from 'services'
import type { ITheme } from 'store/theme/types'

type SettingsToUpdate = {
  styles?: ITheme
  view_certificate_url?: string
  // VERA-362 — per-company override for the host used in transactional email
  // links. Only takes effect once the email sending domain is verified.
  link_host?: string | null
}

type UseUpdateCompanySettingsParams = {
  companyId: string
  settings: SettingsToUpdate
}

const updateCompanySettings = async (params: UseUpdateCompanySettingsParams): Promise<void> => {
  const { companyId, settings } = params

  await createApiCall({ 
    method: 'PUT',
    url: `/companies/admin/${companyId}/settings`,
    data: settings,
  })
}

export const useUpdateCompanySettings = (): UseMutationResult<void, Error, UseUpdateCompanySettingsParams> => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: UseUpdateCompanySettingsParams) => updateCompanySettings(params),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['companyStyles', variables.companyId] })
      queryClient.invalidateQueries({ queryKey: ['companySettings', variables.companyId] })
    },
    onError: (error) => {
      console.error(error)
    },
  })
}